import { monFetch } from "../../inc/inc";
import Cookies from "js-cookie";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";
import CheckBoxMon from "../../elementi/CheckBoxMon";
import Popup from "../../elementi/Popup";
import Alert from "@mui/material/Alert";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import CircularProgress from "@mui/material/CircularProgress";
import HomeIcon from "@mui/icons-material/Home";
import { Button } from "@mui/material";

const Comp = (props) => {
  let params = useParams();

  const [id, setId] = useState(params.id);

  const [domanda, setDomanda] = useState({});
  const [risposte, setRisposte] = useState([]);

  const [risposteSelezionate, setRisposteSelezionate] = useState([]);
  const [noteInterne, setNoteInterne] = useState("");
  const [noteCliente, setNoteCliente] = useState("");

  const [questionarioCompleto, setQuestionarioCompleto] = useState(false);

  const [popupOpen, setPopupOpen] = useState(false);
  const [visibilitaSpiegazione, setVisibilitaSpiegazione] = useState();

  const toggleVisibilitaSpiegazione = () => {
    setVisibilitaSpiegazione(!visibilitaSpiegazione);
  };

  let NrisposteSelezionate = 0;
  risposte.forEach((risp) => {
    if (risp.checked) {
      NrisposteSelezionate += 1;
    }
  });

  async function queryDomanda() {
    //cerco la domanda giusta al caricamento della pagina
    const res = await monFetch("/surveyGetFirstQuestion", {
      survey_id: Cookies.get("idQuestionario"),
      question_id: id,
    });
    setDomanda(res.question);
    if (!id) {
      setId(res.question.id);
    }

    //vedo se ci sono dati associati e li carico
    if (res.question.customerAnswer) {
      //setto la check per la risposta gia selezionata
      let temp = res.question.answers.filter((el) => {
        return (
          el.id == res.question.customerAnswer.answer_id ||
          el.id == res.question.customerAnswer.answer_id_2 ||
          el.id == res.question.customerAnswer.answer_id_3 ||
          el.id == res.question.customerAnswer.answer_id_4 ||
          el.id == res.question.customerAnswer.answer_id_5
        );
      });
      temp.forEach((el) => {
        el.checked = true;
      });
      let tempR = [];
      tempR.push(res.question.customerAnswer.answer_id);
      tempR.push(res.question.customerAnswer.answer_id_2);
      tempR.push(res.question.customerAnswer.answer_id_3);
      tempR.push(res.question.customerAnswer.answer_id_4);
      tempR.push(res.question.customerAnswer.answer_id_5);
      console.log(tempR);
      setRisposteSelezionate(tempR);

      setNoteCliente(res.question.customerAnswer.customer_note);
      setNoteInterne(res.question.customerAnswer.internal_note);
    }

    if (res.question.answers) {
      setRisposte(res.question.answers);
    }
  }

  async function settaCheckRisposta(array, index, value) {
    let temp = [...array];
    ///cancella caselle se risposta max = 1
    // if (domanda.max_answers == 1) {
    //   temp.forEach((el) => {
    //     el.checked = false;
    //   });

    //   temp.forEach((el) => {
    //     if (el.id == index) {
    //       el.checked = value;
    //     }
    //   });
    // }

    if (NrisposteSelezionate < domanda.max_answers || value == false) {
      //limito risposte max
      temp.forEach((el) => {
        if (el.id == index) {
          el.checked = value;
        }
      });

      setRisposte(temp);

      let temp2 = [...risposteSelezionate];
      // console.log(temp2)
      // console.log(index, risposteSelezionate.includes(index))
      if (!risposteSelezionate.includes(index)) {
        temp2.push(index);
      } else {
        let indexTemp = temp2.indexOf(index);
        console.log(indexTemp);
        temp2.splice(indexTemp, 1);
      }

      console.log(temp2);

      setRisposteSelezionate(temp2);
    }
  }

  async function salvaDomanda(
    e,
    domandaId,
    risposteSelezionate,
    procediSeNulla = false
  ) {
    console.log(risposteSelezionate);
    // return;
    if (risposteSelezionate.length == 0 && !procediSeNulla) {
      setPopupOpen(true);
      return;
    }

    //vedo se l'utente ha saltato la risposta
    let skipped = 0;

    if (risposteSelezionate.length == 0 && procediSeNulla) {
      skipped = 1;
    }

    //salva risposta
    let res = await monFetch("/customerAnswerSet", {
      survey_id: Cookies.get("idQuestionario"),
      question_id: domandaId,
      answer_id: risposteSelezionate,
      internal_note: noteInterne,
      customer_note: noteCliente,
      skipped: skipped,
    });

    if (!res.success) {
      return;
    }

    //carica domanda successiva
    res = await monFetch("/surveyGetNextQuestion", {
      survey_id: Cookies.get("idQuestionario"),
      question_id: domanda.id,
    });

    console.log(res)
    if (res.success) {
      setDomanda(res.question);
      if (res.question.answers) {
        setRisposte(res.question.answers);
      }

      setRisposteSelezionate(null);
      setNoteCliente("");
      setNoteInterne("");
      setPopupOpen(false);

      if (res.question.customerAnswer) {
        //setto la check per la risposta gia selezionata
        let temp = res.question.answers.filter((el) => {
          return (
            el.id == res.question.customerAnswer.answer_id ||
            el.id == res.question.customerAnswer.answer_id_2 ||
            el.id == res.question.customerAnswer.answer_id_3 ||
            el.id == res.question.customerAnswer.answer_id_4 ||
            el.id == res.question.customerAnswer.answer_id_5
          );
        });
        temp.forEach((el) => {
          el.checked = true;
        });

        let tempR = [];
        tempR.push(res.question.customerAnswer.answer_id);
        tempR.push(res.question.customerAnswer.answer_id_2);
        tempR.push(res.question.customerAnswer.answer_id_3);
        tempR.push(res.question.customerAnswer.answer_id_4);
        tempR.push(res.question.customerAnswer.answer_id_5);
        setRisposteSelezionate(tempR);
        setNoteCliente(res.question.customerAnswer.customer_note);
        setNoteInterne(res.question.customerAnswer.internal_note);
      }
    }
    if (res.end) {
      //se questionario completo
      setQuestionarioCompleto(true);
      setTimeout(() => {
        window.location.href =
          process.env.PUBLIC_URL +
          "/questionario/" +
          Cookies.get("idQuestionario");
      }, 4000);
    }
  }

  useEffect(() => {
    queryDomanda();
  }, []);

  return domanda.secName ? (
    <>
      <div className="flexSpaceBetween" style={{ alignItems: "center" }}>
        <HomeIcon
          style={{ cursor: "pointer" }}
          onClick={() => {
            window.location.href =
              process.env.PUBLIC_URL +
              "/questionario/" +
              Cookies.get("idQuestionario") +
              "?dom=" +
              id;
          }}
        />
        {!questionarioCompleto ? (
          //se questionario non completato
          <form
            style={{ width: "80%", maxWidth: "1200px" }}
          // onSubmit={(e) => salvaDomanda(e, domanda.id, risposteSelezionate)}
          >
            <h1>{domanda.secName}</h1>
            <h2 style={{ marginBottom: 10 }}>{domanda.subsecName}</h2>
            <div className="numeroDomanda">
              Domanda <b>{domanda.order}</b> di <b>{domanda.countQuestions}</b>
            </div>
            <div
              style={{
                marginBottom: "5px",
                display: "flex",
                gap: 15,
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h4
                dangerouslySetInnerHTML={{
                  __html: domanda.text,
                }}
              ></h4>
              <b>
                Risp. {NrisposteSelezionate}/{domanda.max_answers}
              </b>
            </div>
            <small
              style={{ cursor: "pointer" }}
              onClick={toggleVisibilitaSpiegazione}
            >
              Spiegazione...
            </small>
            <div style={{ marginBottom: "20px" }}>
              {visibilitaSpiegazione ? (
                <div
                  dangerouslySetInnerHTML={{ __html: domanda.internal_note }}
                ></div>
              ) : (
                ""
              )}
            </div>
            {risposte.map((el, index) => {
              if (!el.checked) {
                el.checked = false;
              }
              return (
                <div key={el.id} className="valign">
                  <CheckBoxMon
                    inline={1}
                    checked={el.checked}
                    onChange={(e) =>
                      settaCheckRisposta(risposte, el.id, e.target.checked)
                    }
                  />
                  <span>{el.text}</span>
                  {/* {el.commercial_note ? 
                <span style={{marginLeft: 30}}> <b>Note commerciale:</b> {el.commercial_note}</span>
              :""}
              {el.internal_note ? 
                <span style={{marginLeft: 0}}> | <b>Note interne:</b> {el.internal_note}</span>
              :""} */}
                </div>
              );
            })}
            {/* <Grid container spacing={2}>
          {domanda.commercial_note && (
            <Grid item sm={6} xs={12}>
              <h4>Note commercialo domanda:</h4>
              <p
                dangerouslySetInnerHTML={{ __html: domanda.commercial_note }}
              ></p>
            </Grid>
          )}
          {domanda.internal_note && (
            <Grid item sm={6} xs={12}>
              <h4>Note interne domanda:</h4>
              <p
                dangerouslySetInnerHTML={{ __html: domanda.internal_note }}
              ></p>
            </Grid>
          )}
        </Grid> */}

            <br />
            <Grid container spacing={2}>
              <Grid item xs={12} style={{ textAlign: "right" }}>
                <Button
                  variant="contained"
                  className="buttonSalva"
                  onClick={(e) => {
                    salvaDomanda(e, domanda.id, risposteSelezionate);
                  }}
                >
                  Successiva
                </Button>
              </Grid>
              <Grid item sm={6} xs={12}>
                <h4>Annotazioni del cliente:</h4>
                <CKEditor
                  config={{
                    placeholder: "Annotazioni del cliente...",
                    toolbar: ["bold", "italic", "|", "undo", "redo"],
                  }}
                  editor={ClassicEditor}
                  data={noteCliente || ""}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setNoteCliente(data);
                  }}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <h4>Note intervistatore:</h4>
                <CKEditor
                  config={{
                    placeholder: "Note intervistatore...",
                    toolbar: ["bold", "italic", "|", "undo", "redo"],
                  }}
                  editor={ClassicEditor}
                  data={noteInterne || ""}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setNoteInterne(data);
                  }}
                />
              </Grid>
            </Grid>
          </form>
        ) : (
          //se questionario completato
          <Alert severity="success" style={{ marginTop: 200 }}>
            Hai risposto all'ultima domanda. Verrai reindirizzato al riepilogo
            del questionario.
          </Alert>
        )}
        <div>{/* box vuoto per centrare il contenuto */}</div>
        {/* <ArrowForwardIosIcon
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            salvaDomanda(e, domanda.id, risposteSelezionate);
          }}
        /> */}

        <Popup
          open={popupOpen}
          fnAnnulla={() => {
            setPopupOpen(false);
          }}
          fnSuccess={(e) => {
            salvaDomanda(e, domanda.id, risposteSelezionate, true);
          }}
          titolo={"Risposta non compilata"}
          testo={"Confermi di procedere ugualmente?"}
        />
      </div>
    </>
  ) : (
    <CircularProgress />
    // <h2>Nessuna domanda</h2>
  );
};

export default Comp;
